import stringUtils from "../assets/js/stringUtil.js";


	export function getLoginUserInfo() {
		var userInfo = JSON.parse(localStorage.getItem('logInfo'));
		if (userInfo == null) {
			userInfo = JSON.parse(stringUtils.getCookies("logInfo"));
		}
		if(userInfo && userInfo.timestamp && userInfo.timestamp <= new Date().getTime()){
			localStorage.removeItem('logInfo');
			userInfo = null;
			var date=new Date();
			date.setTime(date.getTime()-10000);
			document.cookie ="logInfo='';expires=" + date.toGMTString()+";";
		}
		return userInfo;
	}
